import 'detect-autofill';
import { mount } from '../../../js/dom-lifecycle';

const FIELDS = '.form-outline input, .form-outline textarea';
const NOTCH = `
    <div class="form-notch">
        <div class="form-notch-leading"></div>
        <div class="form-notch-middle"></div>
        <div class="form-notch-trailing"></div>
    </div>
`;

function updateField(field) {
    field.classList.toggle('active', field.value != '');
    if (field.type == 'date') {
        field.style.opacity = field.value || field == document.activeElement ? 1 : 0;
    }
}

mount('.form-outline, .form-outline-select', function () {
    if (!this.querySelector(':scope > .form-notch')) {
        this.insertAdjacentHTML('beforeend', NOTCH);
    }

    const label = this.querySelector('label');
    const field = this.querySelector('input, textarea');
    if (label) {
        const middle = this.querySelector('.form-notch-middle');
        new ResizeObserver(() => middle.style.width = `${label.clientWidth * 0.8 + 8}px`).observe(label);
    } else if (field) {
        field.classList.add('placeholder-active');
    }
    if (field && this.classList.contains('form-outline')) {
        updateField(field);
    }
});

mount('.form-outline-select .ts-wrapper', function () {
    this.classList.add('active');
});

['input', 'change', 'focus', 'blur'].forEach((type) => document.addEventListener(type, (e) => {
    if (e.target.matches?.(FIELDS)) {
        updateField(e.target);
    }
}, true));

document.addEventListener('onautocomplete', (e) => {
    if (e.target.matches?.(FIELDS)) {
        e.target.classList.add('active');
    }
});

document.addEventListener('reset', (e) => {
    setTimeout(() => e.target.querySelectorAll(FIELDS).forEach(updateField));
});
